module.exports = __webpack_public_path__ + "static/el_jefe_band-b9eba88e858261bc3caadb1bd6619622.jpg";